import type { SVGProps } from 'react'
const SvgSyUpload = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M6.457 8.234a4.447 4.447 0 0 0-4.436 4.436v4.875a4.446 4.446 0 0 0 4.436 4.434h11.129a4.446 4.446 0 0 0 4.435-4.434v-4.887a4.435 4.435 0 0 0-4.423-4.424h-.944a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.944c1.623 0 2.923 1.3 2.923 2.924v4.887a2.924 2.924 0 0 1-2.935 2.934H6.457a2.924 2.924 0 0 1-2.936-2.934V12.67a2.925 2.925 0 0 1 2.936-2.936h.932a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
			<path d="M12.021 1.441a.75.75 0 0 0-.75.75v12.04a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V2.19a.75.75 0 0 0-.75-.75" />
			<path d="M12.021 1.441a.75.75 0 0 0-.53.221L8.573 4.59a.75.75 0 0 0 .004 1.06.75.75 0 0 0 1.06-.002l2.383-2.394 2.385 2.394a.75.75 0 0 0 1.06.002.75.75 0 0 0 .003-1.06l-2.916-2.928a.75.75 0 0 0-.532-.22" />
		</g>
	</svg>
)
export default SvgSyUpload
